import React from 'react';

import { flagStyles } from '../settings';

const SvgEC = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1464px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgEC;
